var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseCardBody',[_c('h3',{staticClass:"text-base font-medium mb-4"},[_vm._v(" "+_vm._s(_vm.$t('importContactsModal.importStartedSection.title'))+" ")]),_c('p',[_vm._v(_vm._s(_vm.$t('importContactsModal.importStartedSection.notice')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }